export default {
    refurbish_device_title: "Restaurar Dispositivo",
    refurbish_device_command_sent_to_the_device: "Dispositivo Restaurado",
    refurbish_device_error_sending_the_command: "Error al restaurar del dispositivo",
    refurbish_device_label: "Este proceso marcará el dispositivo real como reacondicionado, liberando los datos de registro del dispositivo, para que esté pueda ser usado nuevamente desde la importación de dispositivos.",
    refurbish_device_refurbish: "Restaurar",
    refurbish_device_esn: "ESN",
    refurbish_device_imei: "IMEI",
    refurbish_device_sim_provider_account:"Cuenta Proveedor SIM",
    refurbish_device_sim_number: "# de SIM",
    refurbish_device_phone_number: "# de Teléfono"
}